<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>Modify other workflow context:</label>
  </div>

  <div class="cell small-12">
    <label>
      Other workflow Id Rule:
      <input type="text" [(ngModel)]="seConfiguration.otherworkflowIdExpression" />
    </label>
  </div>
  <div class="cell" [ngClass]="{ 'small-12' : !seConfiguration.transformMultiple,  'small-11' : seConfiguration.transformMultiple }">
    <div class="checkbox">
      <input class="show-for-sr" id="chkMultiple" type="checkbox" [(ngModel)]="seConfiguration.transformMultiple" />
      <label for="chkMultiple">
        <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Transform Multiple Workflows
      </label>
    </div>
  </div>
  @if (seConfiguration.transformMultiple) {
    <div class="cell small-1">
      @if (!showWarning) {
        <button (click)="showWarning = !showWarning">
          <svg-icon icon="icon-caret-right" class="small black"></svg-icon>
        </button>
      }
      @if (showWarning) {
        <button (click)="showWarning = !showWarning">
          <svg-icon icon="icon-caret-down" class="small black"></svg-icon>
        </button>
      }
    </div>
  }
  @if (seConfiguration.transformMultiple) {
    <div class="cell small-12">
      @if (showWarning) {
        <span class="bold">Note:</span> When transforming a variable number of other workflows, the following must be considered.  For each transformation rule:
        <ol>
          <li>You must indicate whether the source data is expected to be a list of values.</li>
          <li>If the source is a list, you must indicate whether each of the transformed workflows will receive a single item, based on order, or all of the source items.</li>
          <li>If copying only single items, if there are more items in the source list than the number of workflows, remaining items will not be copied to <span class="bold">any</span> new workflow.</li>
          <li>If copying only a single item, if there are fewer items in the source list than the number of workflows, excess workflows will <span class="bold">not</span> have a value copied to them for the specified rule.</li>
        </ol>
      }
    </div>
  }
</div>
<div class="grid-x grid-margin-x margin-top">
  <div class="cell small-12">
    <button class="button" (click)="addTransformation(addRule())">Add</button>
  </div>
  @for (wf of seConfiguration.transformations; track wf; let i = $index) {
    <div class="cell small-1">Target:</div>
    <div class="cell small-9 padding-left padding-right-small">
      <input type="text" [(ngModel)]="wf.rule.name" />
    </div>
    <div class="cell small-2 text-align-left">
      <button class="button" (click)="removeTransformation(wf)">
        <svg-icon icon="icon-trash" class="small black"></svg-icon>
      </button>
    </div>
    <div class="cell small-12">
      <rules-editor placeholder="Expression" [expression]="wf.rule.expression" (updateRule)="transformUpdated($event, i)"></rules-editor>
    </div>
    <div class="cell small-12">
      The rule will only be updated once it successfully compiles.
    </div>
    <div class="cell small-12">
      <div class="checkbox">
        <input class="show-for-sr" [id]="'chkArray' + i" type="checkbox" [(ngModel)]="seConfiguration.transformations[i].arrayExpected" />
        <label [for]="'chkArray' + i">
          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Source will be a list of values.
        </label>
      </div>
    </div>
    <div class="cell small-12">
      <div class="checkbox">
        <input class="show-for-sr" [id]="'chkTarget' + i" type="checkbox" [(ngModel)]="seConfiguration.transformations[i].targetIsArray" />
        <label [for]="'chkTarget' + i">
          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Treat Target as list of values.
        </label>
      </div>
    </div>
    @if (seConfiguration.transformations[i].targetIsArray) {
      <div class="cell small-11 bold">
        <span class="bold">Note:</span> Treating the target as a list of values will have the following effects:
      </div>
      <div class="cell small-1">
        @if (!showListNote) {
          <button (click)="showListNote = !showListNote">
            <svg-icon icon="icon-caret-right" class="small black"></svg-icon>
          </button>
        }
        @if (showListNote) {
          <button (click)="showListNote = !showListNote">
            <svg-icon icon="icon-caret-down" class="small black"></svg-icon>
          </button>
        }
      </div>
      @if (showListNote) {
        <div class="cell small-12">
          <ol>
            <li>The data at the target location will become a list, if it isn't.</li>
            <li>Any non-list values in the target will be added to the resulting list.</li>
            <li>Values from this transformation will be appended to the resulting list.</li>
          </ol>
        </div>
      }
    }
    @if (seConfiguration.transformations[i].arrayExpected && seConfiguration.transformMultiple) {
      <div class="cell small-12">
        <span class="bold">Note:</span>  If the source data is indicated that it is supposed to be a list, but the data that is received is not a list, no data will be copied.
      </div>
      <div class="cell small-12">
        <div class="checkbox">
          <input class="show-for-sr" [id]="'chkCopyAll' + i" type="checkbox" [(ngModel)]="seConfiguration.transformations[i].copyAll" />
          <label [for]="'chkCopyAll' + i">
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Copy all items to target workflow.
          </label>
        </div>
      </div>
      @if (!seConfiguration.copyAll) {
        <div class="cell small-12">
          Single items will be copied from the source list, based on order, to the target workflows.
        </div>
      }
    }
  }
  <hr class="horizontal-rule" />
</div>